// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"9ccb7669","114":"04cee71f","503":"73019988","805":"6973bc51","836":"5c67403e"}[chunkId] + ".chunk.css";
};